import { CommerceTypes } from 'mxp-schemas';
import { User as UserUtils } from 'mxp-utils';

export const getMaxNonMemberPrice = (currency: string, prices: CommerceTypes.Price[] | undefined) =>
  prices
    ?.filter(
      price =>
        price.value.currencyCode === currency &&
        (price.channel?.obj?.key === UserUtils.CORRECT_NON_MEMBER_CHANNEL_KEY ||
          price.channel?.obj?.key === UserUtils.INCORRECT_NON_MEMBER_CHANNEL_KEY)
    )
    .reduce<CommerceTypes.Price | null>(
      (max, price) => (!max || price.value.centAmount > max.value.centAmount ? price : max),
      null
    ) ?? null;
